import { apiSlice } from '../../../store/api/apiSlice';

/** One piece of implementation detail about an email. */
export interface EmailPreviewFact {
  label: string;
  value: string;
}

/** One email rendered under one set of conditions. */
export interface EmailPreviewState {
  id: string;
  name: string;
  /** What this state renders, in terms of what a reader would see. */
  description: string;
  subject: string;
  html: string;
  text: string;
  links: string[];
}

/** One template, with every state worth reviewing. */
export interface EmailPreview {
  key: string;
  name: string;
  recipient: string;
  description: string;
  technical: EmailPreviewFact[];
  states: EmailPreviewState[];
}

/** The configured SendGrid sender — the same From name and address every real send uses. */
export interface EmailPreviewSender {
  name: string;
  email: string;
}

export interface ListEmailPreviewsResponse {
  sender: EmailPreviewSender;
  emails: EmailPreview[];
}

export const emailPreviewsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    listEmailPreviews: builder.query<ListEmailPreviewsResponse, void>({
      query: () => '/admin/email-previews',
    }),
  }),
});

export const { useListEmailPreviewsQuery } = emailPreviewsApi;
